/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * VxTooltip component.
 */
export class VxTooltip {
    constructor() {
        this.text = undefined;
        this.clickOpen = false;
        this.delay = 3000;
        this.showTooltip = false;
    }
    /**
     * Function that displays the tooltip.
     */
    openTooltip() {
        if (this.clickOpen) {
            this.showTooltip = true;
            setTimeout(() => {
                this.showTooltip = false;
            }, this.delay);
        }
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        return (h(Host, { key: 'b73c5b7029988c23106df076c5d5b56e653d5ad7' }, h("div", { key: '48ef6bb352d4165820d232233f2780045f9285f9', class: `vx_tooltip__container ${!this.clickOpen ? 'vx_tooltip__container--hoverable' : ''}` }, (this.showTooltip || !this.clickOpen)
            ? h("div", { class: `vx_tooltip__content ${!this.clickOpen ? 'vx_tooltip__content--hoverable' : ''}`, role: "tooltip" }, this.text)
            : '', h("div", { key: '4be1f6f0b040e39a09a9c17b5320eba66a4b1ce2', class: "vx_tooltip__parent", onClick: () => this.openTooltip() }, h("slot", { key: '59747a7ca20e8f7066c093570c9baaa79e99aa26', name: 'vx-tooltip-slot' })))));
    }
    static get is() { return "vx-tooltip"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-tooltip.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-tooltip.css"]
        };
    }
    static get properties() {
        return {
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text of the tooltip."
                },
                "attribute": "text",
                "reflect": false
            },
            "clickOpen": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Open by click."
                },
                "attribute": "click-open",
                "reflect": false,
                "defaultValue": "false"
            },
            "delay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Delay of Tooltip."
                },
                "attribute": "delay",
                "reflect": false,
                "defaultValue": "3000"
            }
        };
    }
    static get states() {
        return {
            "showTooltip": {}
        };
    }
}
//# sourceMappingURL=vx-tooltip.js.map
